import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminSubpage from "../components/AdminSubpage";
import { auctionsAPI } from "../services/api";
import "../components/Auctions.css";

const AuctionResultsPage = () => {
  const { auctionId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    auctionsAPI.getResults(auctionId).then((res) => setData(res.data));
  }, [auctionId]);

  const exportCsv = () => {
    const rows = [["Item", "Winner", "Final price", "Reserve met"]];
    (data.items || []).forEach((i) => {
      rows.push([
        i.title,
        i.winner?.name || "",
        i.final_price,
        i.reserve_met ? "Yes" : "No",
      ]);
    });
    const csv = rows.map((r) => r.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `auction-${auctionId}-results.csv`;
    a.click();
  };

  if (!data) {
    return (
      <AdminSubpage title="Auction results" backTo="/auctions">
        <div className="loading">Loading…</div>
      </AdminSubpage>
    );
  }

  return (
    <AdminSubpage title="Auction results" backTo="/auctions">
      <div className="admin-page-panel modal-content">
        <div className="auction-live-stats">
          <div className="auction-live-stat">
            <label>Total GMV</label>
            <strong>AED {data.total_gmv}</strong>
          </div>
          <div className="auction-live-stat">
            <label>Items</label>
            <strong>{(data.items || []).length}</strong>
          </div>
        </div>

        <button type="button" className="btn btn-secondary" onClick={exportCsv}>
          Export CSV
        </button>

        <div className="table-container" style={{ marginTop: 16 }}>
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Winner</th>
                <th>Final price</th>
                <th>Reserve met?</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {(data.items || []).map((i) => (
                <tr key={i.item_id} className={`table-row-status table-row-status-${i.status}`}>
                  <td>{i.title}</td>
                  <td>{i.winner?.name || "—"}</td>
                  <td>AED {i.final_price}</td>
                  <td>{i.reserve_met ? "Yes" : "No"}</td>
                  <td>{i.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminSubpage>
  );
};

export default AuctionResultsPage;
